"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OWNED_ENTITY_SUBJECTS = void 0;
exports.buildFrontendAuth = buildFrontendAuth;
const authentication_types_1 = require("./authentication.types");
const session_1 = require("./session");
exports.OWNED_ENTITY_SUBJECTS = [
    'analysisResult',
    'extractionConfig',
    'file',
    'finding',
    'moduleResolution',
    'organization',
    'package',
    'packageFamily',
    'pinoutValidation',
    'project',
    'revision',
];
function buildFrontendAuth(session, options) {
    const accessibleOwnerIds = [
        session.actor.userId,
        ...session.memberships.filter((m) => m.role !== authentication_types_1.MembershipRole.Trainee).map((m) => m.groupId),
    ];
    const staff = (0, session_1.isStaff)(session);
    const useStaffPermissions = staff && !options?.viewAsRole;
    if (useStaffPermissions) {
        return {
            accessibleOwnerIds,
            isStaff: true,
            rules: [
                ...exports.OWNED_ENTITY_SUBJECTS.map((subject) => ({
                    action: 'manage',
                    subject,
                })),
                {
                    action: 'manage',
                    subject: 'devTools',
                },
                {
                    action: 'manage',
                    subject: 'legacyFinding',
                },
                {
                    action: 'manage',
                    subject: 'tag',
                },
                {
                    action: 'manage',
                    subject: 'manufacturer',
                },
                {
                    action: 'manage',
                    subject: 'wizard',
                },
                {
                    action: 'manage',
                    subject: 'wizardAdmin',
                },
                {
                    action: 'manage',
                    subject: 'membership',
                },
            ],
        };
    }
    const rules = [
        {
            action: 'view',
            subject: 'analysisResult',
            conditions: {
                ownerId: {
                    $in: accessibleOwnerIds,
                },
            },
        },
        {
            action: 'view',
            subject: 'file',
            conditions: {
                ownerId: {
                    $in: accessibleOwnerIds,
                },
            },
        },
        {
            action: 'manage',
            subject: 'finding',
            conditions: {
                ownerId: {
                    $in: accessibleOwnerIds,
                },
            },
        },
        {
            action: 'view',
            subject: 'moduleResolution',
            conditions: {
                ownerId: {
                    $in: accessibleOwnerIds,
                },
            },
        },
        {
            action: 'view',
            subject: 'organization',
            conditions: {
                ownerId: {
                    $in: accessibleOwnerIds,
                },
            },
        },
        {
            action: 'view',
            subject: 'package',
            conditions: {
                ownerId: {
                    $in: accessibleOwnerIds,
                },
            },
        },
        {
            action: 'manage',
            subject: 'project',
            conditions: {
                ownerId: {
                    $in: accessibleOwnerIds,
                },
            },
        },
        {
            action: 'manage',
            subject: 'revision',
            conditions: {
                ownerId: {
                    $in: accessibleOwnerIds,
                },
            },
        },
    ];
    const adminIds = (0, session_1.adminOrgIds)(session);
    if (adminIds.length > 0) {
        rules.push({
            action: 'manage',
            subject: 'membership',
            conditions: {
                ownerId: {
                    $in: adminIds,
                },
            },
        }, {
            action: 'manage',
            subject: 'organization',
            conditions: {
                ownerId: {
                    $in: adminIds,
                },
            },
        });
    }
    if (options?.hasWizardAccess) {
        rules.push({
            action: 'manage',
            subject: 'wizard',
        });
    }
    if (options?.hasWizardAdminAccess) {
        rules.push({
            action: 'manage',
            subject: 'wizardAdmin',
        });
    }
    if (options?.hasPlanSelectorAccess) {
        rules.push({
            action: 'manage',
            subject: 'planSelector',
        });
    }
    return {
        accessibleOwnerIds,
        isStaff: staff,
        rules,
    };
}
//# sourceMappingURL=frontend-auth.js.map